<template>
<div>
<loading :active.sync="isLoading"></loading>
 <Navbar></Navbar>
    <div class="container">
        <div class="card-login mx-auto centerwidth">
            <span style="font-size:30px">會員登入           </span>
            <div class="card-body fromve">
                <!-- <form @submit.prevent="submit"> -->
                    <div class="input-group form-group ">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                        </div>
                        <input type="text" v-model="form.email" name="email" class="form-control" placeholder="E-Mail">
                    </div>

                    <div class="input-group form-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-key"></i></span>
                        </div>
                        <input type="password" v-model="form.password" name="password" class="form-control" placeholder="Password">
                    </div>
                 <div class="input-group">
                      <vue-recaptcha 
                      ref="recaptcha"
                      size="invisible"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                      sitekey="6LeIq_sUAAAAAET-nKNiu8_Pz88jE8_qQ8L2DFoG">
                    </vue-recaptcha>
                 </div>
                   

                    <div class="form-group form-groupunder">
                        <div class="row">
                            <div class="col">
                                <!-- <input type="submit" name="btn" value="登入" class="btn btn-outline-danger float-right login_btn"> -->
                                <button @click="submit" class="btn btn-outline-danger float-right login_btn">登入</button>
                            </div>
                        </div>
                    </div>
                <!-- </form> -->
            </div>
        </div>
        <div class="row justify-content-end">
            <div class="col- under">
                <router-link class="nav-link" to="/forgetpassword"><span style="font-size:20px">忘記密碼?</span></router-link>
            </div>
            <div class="col-6 under">
                <router-link class="nav-link" to="/registered"><span style="font-size:20px">立即註冊</span></router-link>
            </div>
        </div>

    </div>

    <Footer></Footer>
</div>
</template>

<script>
import axios from 'axios';
import Navbar from '../../components/Layout/Navbar';
import Footer from '../../components/Layout/Footer';
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    Navbar,
    Footer,
    VueRecaptcha
  },
    name: 'login',
    data() {
        return {

            form: {
                email: '',
                password: '',
                ip:'',
                recaptcha:''
            },
            data: '',
            isLoading:false,//加入讀取效果
            user:'',
            
        }
    },

    methods: {
        submit() {
             const vm=this;
             vm.isLoading=true;
             vm.$refs.recaptcha.execute();
            //  localStorage.setItem("verificationPassword",vm.form.password);//儲存Password做完判斷是否有驗證用
           
           
        },
        onCaptchaVerified: function (recaptchaToken) {
             const vm = this;
             vm.$refs.recaptcha.reset();

              if(vm.form.email =='' ){
                alert('請輸入帳號');
                vm.isLoading=false;
            }
            else if(vm.form.password==''){
                alert('請輸入密碼');
                  vm.isLoading=false;
            }
            else{
                 vm.form.recaptcha=recaptchaToken
                 const signin_api = `${process.env.APIPATH}/signin`;
                 axios.post(signin_api, vm.form)
                .then((res) => {
                    // this.$parent.$children[0].token = res.data.token;
                    // this.$parent.$children[0].success = true;
                    // this.$parent.$children[0].ckecklogout;
                    // console.log(this.$parent.$children[0]);
                    if(res.data=='you are robot!!'){
                        alert('請勿嘗試登入!!')
                        vm.form = '';
                        vm.isLoading=false;
                    }else{
                         localStorage.setItem('usertoken', res.data.token);
                         localStorage.setItem("verificationEmail",vm.form.email);//儲存EMAIL做完判斷是否有驗證用
                         vm.checkVerify();//判斷是否已驗證成功
                    }
                    
                   
                })
                .catch((err) => {
                    console.log(err)
                     vm.isLoading=false;
                    alert('密碼或帳號錯誤');
                })
            }
        },
         onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
       },
        //是否驗證
        checkVerify() {
           
            const token = localStorage.getItem('usertoken'); 
            const headers = {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            };
            const data = {};
            const me_api = `${process.env.APIPATH}/me`;
            axios.post(me_api, data, headers)
                .then((res) => {
                    let record = res.data;
                    
                   localStorage.setItem("verifiedEmail",record.email_verified_at);
                    if (record.email_verified_at != null) {
                        localStorage.removeItem('verificationEmail')
                        
                        // localStorage.removeItem('verificationPassword')
                         this.form = '';
                         this.username();  //取得使用者名稱
                         this.$router.push('/member');                   
                    } else {
                        //  this.$router.push('/complete');
                        this.isLoading=false;
                        alert('請聯絡管理人員開通帳號');
                        this.$router.push('/login');
                        // this.sendMail(record.email);
                        // alert('驗證信已發送，請至信箱收信驗證');
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        //寄驗證信
        sendMail(email){
          const api2 = `${process.env.APIPATH}/send/`+email;
          this.$http.get(api2).then(response => {
              // console.log((this.current_data = response.data.steam_data));
          });
        },
        //取得使用者名稱
    username(){
       
        const token= localStorage.getItem('usertoken');
        const headers = {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        }
        const data = {};
        const me_api = `${process.env.APIPATH}/me`;
        axios.post(me_api, data, headers)
          .then((res) => {
            let record = res.data;
           
            // this.user = record.name
            // this.$router.push({name: 'member', params: {username: this.user}})
            this.$router.push("/member");
          })
          .catch((err) => {
            console.log(err)
          })
        },
        //抓使用者ip
        getIp(){
            const api = `https://ipapi.co/json/`;
            axios.post(api)
            .then((res) => {
                let record = res.data;
                this.form.ip =  record.ip;
            })
            .catch((err) => {
                console.log(err)
            })
        } 
    },created: function () {
        const vm=this;
        vm.getIp();
        //   window.localStorage.clear();//全部移除

        
        
         
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped src="@/assets/css/login.css"></style>



// WEBPACK FOOTER //
// src/components/page/login.vue